import { onDomReady } from '../utils/dom';

export class Header {
    static root;
    static inside;
    static container;
    static cache = {
        offset: null,
        innerHeight: null,
        fixedPos: null,
    };

    // Gets called once when the class is first used.
    static {
        const root = document.getElementById('header');
        const inside = root.querySelector('.header_inside');
        const container = document.querySelector('#header + div');

        if (!root || !inside || !container) {
            throw new Error('Could not find header elements.');
        }

        this.root = root;
        this.inside = inside;
        this.container = container;
    }

    // Get the current height of the header (including contact bar).
    static getHeight = (noCache = false) => {
        if (noCache) {
            return (this.cache.offset = this.container.offsetTop.toFixed(0));
        }

        return (this.cache.offset ??= this.container.offsetTop.toFixed(0));
    };

    // Get the current height of header_inside.
    static getInnerHeight = () => (this.cache.innerHeight ??= this.inside.getBoundingClientRect().height.toFixed(1));

    // Get the position from which the header should be fixed.
    static getFixedPosition = () => (this.cache.fixedPos ??= window.innerHeight / 2);

    static clearCache = () => Object.keys(this.cache).forEach((i) => (this.cache[i] = null));
}

function showFixedHeader() {
    const scrolledTop = document.documentElement.scrollTop;
    const classList = Header.root.classList;

    if (scrolledTop > parseInt(Header.getHeight())) {
        classList.add('sticky');

        if (classList.contains('menu-open') || classList.contains('level-open')) {
            classList.add('keep');
        }

        if (scrolledTop > Header.getFixedPosition()) {
            classList.add('show');
        } else {
            classList.replace('show', 'hide');
        }
    } else {
        classList.remove('sticky', 'hide', 'keep');
    }
}

onDomReady(() => {
    showFixedHeader();
});

window.addEventListener('scroll', () => {
    showFixedHeader();
});

window.addEventListener('resize', () => {
    Header.clearCache();
    showFixedHeader();
});
